<template>
  <div class="home-box1" :style="{ backgroundImage: `url(${bb})` }">
    
    <v-row class="d-flex align-center flex-row justify-center" style="min-height: 90vh;">
      <v-row class="white-bg">
          <v-col cols="12" xs="12" md="5" :style="{ backgroundImage: `url(${newbb})` }"  class="small-bg">
            
             <div class="text-section">
              <p class="text-overlay">
                MAGIC IS IN THE<br> DETAILS
              </p>
              <p class="text-overlay1">
                Please use your credentials to login.
              </p>
             </div>
          </v-col>
          <v-col cols="12" xs="12" md="7" class="form-section">
            <v-layout row v-if="errors" class="ma-3">
              <v-row>
                <Alert @dismissed="onDismissed" :text="errors"></Alert>
              </v-row>
            </v-layout>
            <v-progress-linear class="ma-2" v-if="loading" indeterminate color="blue"></v-progress-linear>
            <div class="pt-10" v-if="showLogin">
              
              <v-form class="">
                
                  <h2 class="labb">Login</h2>
                  <v-text-field outlined dense ame="username" label="Email or Mobile Number" v-model="username"
                  @keydown.enter="login" hint="If mobile, enter without 0 (777xxxxxx)" required style="border-radius: 0px;"></v-text-field>
                  <v-text-field outlined dense  v-model="password" id="password" name="password" label="Password"
                  type="password" @keydown.enter="login" required  style="border-radius: 0px;"></v-text-field>
              </v-form>
              <v-row class="btn-section">
                <v-col cols="12" md="4" sm="12">
                  <v-btn dark color="#00B3FF" block @click="login" :loading="loading" depressed style="border-radius: 20px;">LOGIN</v-btn>
                </v-col>
                <v-col cols="12" md="6" sm="12">
                  <div class="text--left">
                    <v-btn dark color="#00B3FF" text @click="login" :disabled="loading" depressed link
                      to="/forgot-password">Forgot Password?</v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>
        </v-col>
      </v-row>
    </v-row>
  </div>
</template>
 
<script>
import Alert from "@/components/shared/Alert";
import { mapGetters } from "vuex";
// import { AuthService } from "../../services/auth-service.js";
// import { checkError } from "@/config/errors.js";
 
export default {
  name: "Login",
  components: { Alert },
  data() {
    return {
      username: this.$route.query.email || "",
      password: "",
      //errors: null,
      //loading: false,
      showLogin: true,
      logo: require("@/assets/img/apulid.png"),
      banner: require("@/assets/img/login-banner.svg"),
      bb: require("@/assets/img/bb.jpg"),
      newbb: require("@/assets/img/newbb.jpg")
    };
  },
  mounted() {
    this.onDismissed();
  },
  computed: {
    ...mapGetters("auth", {
      errors: "errors",
      isLogged: "token",
      loading: "loading",
      profile: "profile",
    })
  },
 
  methods: {
    // login1() {
    //   this.errors = null;
    //   let data = {
    //     username: this.username,
    //     password: this.password
    //   };
    //   this.loading = true;
    //   AuthService.login1(data)
    //     .then(response => {
          
    //       if (response.status == 200) {
            
    //         if (response.data.user.enable_auth == 0){
    //           this.login();
    //         }else{
    //           this.loading = false;
    //           this.$store.dispatch('auth/setUsername', this.username);
    //           this.$store.dispatch('auth/setPassword', this.password);

    //           this.showLogin = false;
    //           // this.$router.push("/googleAuth");
    //           this.$router.push("/switch");
    //         }
            
 
    //       }
    //     })
    //     .catch((error) => {
    //       this.loading = false;
    //       let data = error.response.data;
    //       let errorOutput = checkError.errorFormatting(data);
    //       this.errors = errorOutput;
          
    //     });
    // },

    login() {
      this.$store
        .dispatch("auth/retrieveToken", {
          username: this.username,
          password: this.password
        })
        .then(response => {
          if (response.status == 200) {
            this.loading = false;
            this.showLogin = false;
            if (response.data.roles && response.data.roles.length > 0) {
              this.$router.push("/switch-role");
            }else if (response.data.require_2fa === true) {
              this.$router.push({ name: '2FA', query: { id: response.data.user, token: response.data.token } })

            } else {
              this.$router.push("/switch-role");
            }
 
          }
        });
    },
    
 
    onDismissed() {
      this.$store.dispatch("auth/clearError");
    }
  }
};
</script>
 
<style>
.login-page {
  padding-bottom: 0px;
}
 
.boarder{
  border-radius: 10px;
}
 
.home-box1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
 
}
 
.white-bg {
  background-color: none;
  border-radius: 15px;
  min-height: 575px;
  margin: 0px 15%;
  padding: 0;
  overflow: hidden;
}
 
.labb {
  padding-bottom: 30px;
}
 
.imgg {
  position: absolute;
  border-radius: 15px;
  height: 560px;
  width: 520px;
}
 
.imgg1 {
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  overflow: hidden;
  width: 515px;
 
}
 
.text-overlay {
  font-size: 40px;
  color: white;
  padding: 10px;
  border-radius: 5px;
  font-weight: 400;
}
 
.text-overlay1 {
  font-size: 17px;
  color: white;
  padding: 10px;
  border-radius: 5px;
}
 
.small-bg {
    background-size: cover;
    background-position: center;
    overflow: hidden;
}
 
.form-section{
  background-color: white;
  padding-left: 8%;
  padding-right: 8%;
  padding-top: 5%;
  padding-bottom: 40px;
}
 
.text-section{
  margin-top:50px;
  margin-left: 25px
}
 
.btn-section{
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}
 
</style>

